import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree, } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequiredGameActionModel } from '../../game/models/required-game-action.model';

import { GameService } from '../../game/services/game.service';

@Injectable({
  providedIn: 'root',
})
export class HasRequiredRoutesGuard implements CanActivate {

  public actions: RequiredGameActionModel[] = [];

  /**
   * Constructor
   *
   * @param {GameService} gameService
   * @param {Router} router
   */
  public constructor(private gameService: GameService, private router: Router) {
  }

  /**
   * Check if the route can be activated
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @return {Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree}
   */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.gameService.loadRequiredRoutes()
    .pipe(
      map((returnedValue: boolean) => {
        return returnedValue;
      }),
    );
  }
}
